import { ThemeProvider } from '@mui/material';
import { RouterProvider } from 'react-router-dom';

import configuredRouter from './router';
import geopardTheme from './themes/geopard';

export default function App() {
  return (
    <ThemeProvider theme={geopardTheme}>
      <RouterProvider router={configuredRouter} />
    </ThemeProvider>
  );
}
